import { type GetLensCategoryListResponse, type MyLensesLensCategory } from "../../gql-generated/types";

export const mapLensCategoryList = (
    lensCategoryList: GetLensCategoryListResponse["lensCategoryList"],
): { data: MyLensesLensCategory; items: MyLensesLensCategory[] }[] => {
    if (!lensCategoryList) {
        return [];
    }

    const { parentLensCategoriesList, subLensCategoriesList } = {
        parentLensCategoriesList: lensCategoryList.parentLensCategoriesList,
        subLensCategoriesList: lensCategoryList.subLensCategoriesList,
    };

    return parentLensCategoriesList.map((parentLensCategory) => {
        const children = subLensCategoriesList.filter(
            (subLensCategory) => subLensCategory.parentId === parentLensCategory.id,
        );
        if (children.length > 0) {
            children.push({ ...parentLensCategory, displayName: "Other" });
        }
        return {
            data: parentLensCategory,
            items: children.length > 0 ? children : [{ ...parentLensCategory }],
        };
    });
};
